<template>
  <div>
    <v-card>
      <v-card-title>Icon Font</v-card-title>

      <v-card-text>
        <v-container fluid>
          <v-row class="mb-4">Usage: &lt;i style="font-size:24px;color:#606060" :class="`ih i-ih_${iconName}`"&gt;&lt;/i&gt;</v-row>
          <v-row class="mb-4"
            >Usage with component: &lt;inno-icon icon-color="primary darken-4" size="20px" icon="${iconName}"&gt;&lt;/inno-icon&gt;
          </v-row>
          <v-row class="mb-10 pb-10">
            <v-col class="ma-0 pa-1" cols="1" v-for="(icon, ind) in icons" :key="ind">
              <!-- <i style="font-size:24px;color:#606060" :class="`ih i-ih_${icon}`"></i> -->
              <inno-icon color="black" icon-color="black darken-3" fontSize="36px" :icon="icon"></inno-icon>
              <div class="" style="font-size: 10px">{{ icon }}</div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import InnoIcon from '@/components/icons/InnoIcon';

export default {
  components: {
    InnoIcon,
  },
  data() {
    return {
      icons: [
        'absenzen',
        'appsatwork_ix',
        'ausbildungsunterlagen',
        'ausfahrtenkontrolle',
        'baustellen',
        'bestellungen',
        'betriebsinfos',
        'bgm_vbz',
        'bus',
        'chauffeurenmappe',
        'dienstbuechlein',
        'diensteinteilung_ix',
        'dienstkleider',
        'diensteinteilung',
        'dienstordnung',
        'dienstplan',
        'diensttausch',
        'docsatwork_ix',
        'diensttausch',
        'docsatwork_ix',
        'document',
        'dokumente_empty',
        'dokumente_pdf',
        'dokumente_stoerungsbehebung_ix',
        'el_wagenbuch',
        'elearning_v2',
        'elearning_v3',
        'elearning',
        'fahrbegleitung',
        'fahrplan_ix',
        'fahrschule',
        'feedback',
        'flugblatt',
        'formulare_v2',
        'fotos_v2',
        'fotos_v2',
        'fotos',
        'freizeit_ix',
        'infowunschnet_ix',
        'instruktion',
        'ivu',
        'kontaktverwaltung',
        'linkmanager',
        'man_bus_ix',
        'marketing',
        'meine_mappe',
        'meldungen',
        'messaging',
        'mitarbeiterfotos',
        'mitarbeiterliste',
        'mitarbeiterzeitung',
        'moonliner_ix',
        'moonliner_v2',
        'news',
        'offline_webseite',
        'paragraph',
        'personal',
        'pikett',
        'pinwand',
        'private_dokumente_ix',
        'prozesse',
        'quality_ix',
        'rapporte',
        'sbb',
        'selbstkontrolle_ix',
        'spesen',
        'subway',
        'technik',
        'tram_ix',
        'unfalldesk',
        'video_play',
        'video_tv',
        'video',
        'webapplikationen',
        'weblink',
        'widgets',
        'xundheit',
        'adressbuch',
        'apps_ix',
        'anleitungen',
      ],
    };
  },
};
</script>

<style></style>
